import React from "react";
import { Link } from "react-router-dom";
import { SvBook, SvLockerDetail } from "../graphql";

type LockerProps = {
  column: number; // 欄
  tier: number; // 列
  list: SvLockerDetail[]; // 所有櫃
  items: Map<number, SvBook>; // 所有書
  selected?: SvBook; // 前台用
  opened?: SvBook; // 前台用
  selectedDetail?: SvLockerDetail; // 管理用
  openedDetail?: SvLockerDetail; // 管理用
  manage?: number; // 1 管理顯示模式
  handleSelected?: any; //
  locked?: boolean; // 鎖住連結不可用
};

export default function Locker({
  column,
  tier,
  list,
  items,
  selected,
  opened,
  selectedDetail,
  openedDetail,
  manage,
  handleSelected,
  locked,
}: LockerProps) {
  const handleSelectBook = (bid: number) => {
    handleSelected(bid);
  };
  const handleSelectDetail = (book?: SvBook, detail?: SvLockerDetail) => {
    handleSelected(book, detail);
  };
  const createLockerDetail = (column: any, tier: any, list: any) => {
    let result = [];
    for (let i = 0; i < column; i++) {
      result.push(
        <section key={i}>
          {list
            .slice(i * tier, i * tier + tier)
            .map((item: any, ii: number) => {
              const index = i * tier + ii;
              const { id, name, status } = item;
              const book = items.get(id);
              const bid = book ? book.id : 0;
              return (
                <div
                  key={index}
                  className={(() => {
                    let statusClass = "box ";
                    if (manage !== 1) {
                      if (book !== undefined) {
                        if (
                          selected !== undefined &&
                          selected.locker_detail_id === id
                        ) {
                          statusClass += "uped selected";
                        } else if (
                          opened !== undefined &&
                          opened.locker_detail_id === id
                        ) {
                          statusClass += "uped open";
                        } else {
                          statusClass += "uped";
                        }
                      }
                    } else if (manage === 1) {
                      if (
                        selectedDetail !== undefined &&
                        selectedDetail.id === id
                      ) {
                        statusClass += "uping";
                      } else if (
                        openedDetail !== undefined &&
                        openedDetail.id === id
                      ) {
                        statusClass += "open";
                      } else if (status === 0) {
                        statusClass += "available";
                      } else if (status === 1) {
                        statusClass += "uped";
                      } else if (status === 8) {
                        statusClass += "abnormal";
                      } else if (status === 9) {
                        statusClass += "repair";
                      }
                    }
                    return statusClass;
                  })()}
                >
                  {manage !== 1 &&
                    (book !== undefined && !locked ? (
                      <Link
                        to={"/book?id=" + bid}
                        onClick={() => handleSelectBook(bid)}
                      >
                        {name}
                      </Link>
                    ) : (
                      <>{name}</>
                    ))}
                  {manage === 1 &&
                    (!locked ? (
                      <Link
                        to=""
                        onClick={() => handleSelectDetail(book, item)}
                      >
                        {name}
                      </Link>
                    ) : (
                      <>{name}</>
                    ))}
                </div>
              );
            })}
        </section>
      );
    }
    return result;
  };

  return (
    <section className="cabinet">
      <div className="scroll-x">
        <div style={{ position: "relative", height: "600px" }}>
          {createLockerDetail(column, tier, list)}
        </div>
      </div>
    </section>
  );
}
